import { Box, Card, Grid, styled, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ReversePagination from '../../../components/ReversePagination';
import BookmarkedPostsItem from './BookmarkedPostsItem';

const BookmarkedSection = ({
  isTablet,
  isMobile,
  postsData = [],
  title = '북마크한 게시글',
  icon = '/static/icons/best.png',
  filterItems = ['전체', '자유게시판', '질문답변', '정보공유', '후기', '모임'],
  onCardClick,
  showAIRecommendButton = false,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleCardClick = item => {
    if (onCardClick) {
      onCardClick(item);
    } else {
      navigate('/naver/callmetellme/jiwongum/post-detail');
    }
  };

  // Default posts data if none provided
  const defaultPostsData = [
    {
      id: 1,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니 세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니 세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '/static/post-image/post-1.png', // Wait, the image in the prompt screenshot might use a specific image or none. I'll keep the existing path but might need to change it if I knew better.
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
    {
      id: 2,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '/static/post-image/post-2.png',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
    {
      id: 3,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '/static/post-image/post-2.png', // Using post-2 for consistency with "image" description if they all looked similar
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
    {
      id: 4,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
    {
      id: 5,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
    {
      id: 6,
      title: '안녕하세요 화이팅입니다~~',
      category: '뒷담화',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.10.24',
    },
  ];

  const dataToUse = postsData.length > 0 ? postsData : defaultPostsData;

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: '0px 0px',
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
          }}
        >
          {/* 커뮤니티 포스트 카드 */}
          <Grid container spacing={1} pt={2}>
            {dataToUse.map((item, index) => (
              <BookmarkedPostsItem
                key={item.id}
                item={item}
                onClick={handleCardClick}
              />
            ))}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                width: '100%',
              }}
            >
              <ReversePagination totalItems={3} />
            </Box>
          </Grid>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default BookmarkedSection;
